import dayjs from "dayjs";
import {timeNow} from "@/utils/helpers";

/**
* Copyright (c) Qwoach LLC 2025. All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Created by Artem Bogush <artem@qwoach.com> on 30.06.25
*
*/
export const InvoiceMode = Object.freeze({
	MONTHLY: "MONTHLY",
	QUARTERLY: "QUARTERLY",
	YEARLY: "YEARLY",
	CONSOLIDATED: "CONSOLIDATED",
})

export const invoiceModeName = (invoiceMode) => {
	switch (invoiceMode){
		case InvoiceMode.MONTHLY:
			return "Monthly"
		case InvoiceMode.YEARLY:
			return "Yearly"
		case InvoiceMode.QUARTERLY:
			return "Quarterly"
		case InvoiceMode.CONSOLIDATED:
			return "Consolidated"
		default:
			throw Error(`Unknown invoice mode: ${invoiceMode}`)
	}
}

export const invoiceModeUpperBoundMs = (invoiceMode, timeMs = timeNow()) => {
	switch (invoiceMode){
		case InvoiceMode.MONTHLY:
			return dayjs(timeMs).endOf("month").valueOf()
		case InvoiceMode.YEARLY:
			return dayjs(timeMs).endOf("year").valueOf()
		case InvoiceMode.QUARTERLY:
			return dayjs(timeMs).endOf("quarter").valueOf()
		case InvoiceMode.CONSOLIDATED:
			return dayjs(timeNow()).endOf("month").valueOf()
	}
}

